import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ApiService } from '../../../ubi-core/ubi-core.module';
import { GlobalState } from '../../../global.state';
import { AuthenticationService } from '../../../auth';

declare var $: any;

@Component({
  selector: 'app-movements',
  templateUrl: './movements.component.html',
  styleUrls: ['./movements.component.scss']
})
export class MovementsMobileComponent implements OnInit {
  private isMobile: boolean;

  constructor(private _baseservice: ApiService, private router: Router, private _state: GlobalState, private auth: AuthenticationService) {
    this._baseservice.setEntity('Movements');

    this.isMobile = window.innerWidth < 501;

    this._state.notifyDataChanged('content.header.css', '');
    this._state.notifyDataChanged('backButton.changeState', false);
    $('.content-top .al-title').text('Movimentos');
    // Hide action button in the top bar
    this._state.notifyDataChanged('actionButton.changeState',
      {
        visible: false,
        class: '',
        title: '',
        action: ''
      });
  }

  ngOnInit() {
    // Clear movements count in the top bar
    $('.content-top .movements-count').text('');
    $('.content-top .total-movements-count').text('');
  }

  public openNew(type, cssClass) {
    this.router.navigateByUrl('mobile/movement/' + type);
    this._state.notifyDataChanged('content.header.css', cssClass);
  }

  private logout() {
    this.auth.logout();
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/mobile/movements/movements.component.ts